function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M301.567 0H0l25.433 20L0 40h301.567L327 20 301.567 0z",
  fill: "#ECCEFC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M610.567 0H309l25.433 20L309 40h301.567L636 20 610.567 0z",
  fill: "#ECCEFC"
});

function SvgStartArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 351 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzUxIDQwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTMwMS41NjcgMEgwTDI1LjQzMzMgMjBMMCA0MEgzMDEuNTY3TDMyNyAyMEwzMDEuNTY3IDBaIiBmaWxsPSIjRUNDRUZDIiAvPgogICAgPHBhdGggZD0iTTYxMC41NjcgMEgzMDlMMzM0LjQzMyAyMEwzMDkgNDBINjEwLjU2N0w2MzYgMjBMNjEwLjU2NyAwWiIgZmlsbD0iI0VDQ0VGQyIgLz4KPC9zdmc+CiAgICA=";
export { SvgStartArrow as ReactComponent };